export const TaskData = [
  {
    id: 1,
    activeTab: "1",
    title: "Created By Me",
  },
  {
    id: 2,
    activeTab: "2",
    title: "Today's Tasks",
  },
  {
    id: 3,
    activeTab: "3",
    title: "Delayed Tasks",
  },
  {
    id: 4,
    activeTab: "4",
    title: "Upcoming Tasks",
  },
  {
    id: 5,
    activeTab: "5",
    title: "This Week Task",
  },
  {
    id: 6,
    activeTab: "6",
    title: "This Month Tasks",
  },
  {
    id: 7,
    activeTab: "7",
    title: "Assigned To Me",
    badge: true,
    color: "primary",
  },
  {
    id: 8,
    activeTab: "8",
    title: "My Tasks",
    badge: true,
    color: "secondary",
  },
];

export const TaskTagDataList = [
  {
    id: 1,
    activeTab: "9",
    title: "Notification",
  },
  {
    id: 2,
    activeTab: "10",
    title: "Newsletter",
  },
  {
    id: 3,
    activeTab: "11",
    title: "Business",
  },
  {
    id: 4,
    activeTab: "12",
    title: "Holidays",
  },
];

export const timeList = ["7:00 am", "7:30 am", "8:00 am", "8:30 am", "9:00 am", "9:30 am", "10:00 am", "10:30 am", "11:00 am", "11:30 am", "12:00 am", "12:30 am", "1:00 pm", "2:00 pm", "3:00 pm", "4:00 pm"];
